// 仅控制2.5D预览的视野；平移/缩放不进入地图配置或业务坐标。
export default {
  data () { return { cameraX: 0, cameraY: 0, cameraDrag: null, cameraBlockClickUntil: 0, cameraViewportWidth: 0 } },
  computed: {
    minZoom () { return this.isIsometric ? .6 : 1 },
    maxZoom () { return this.isIsometric ? 4 : 3 },
    zoomDisplay () { return Number(this.zoom.toFixed(2)) },
    mapStageStyle () {
      return this.isIsometric
        ? { width: '100%', transform: `translate(${this.cameraX}px, ${this.cameraY}px) scale(${this.zoom})`, transformOrigin: '0 0' }
        : { width: `${this.zoom * 100}%` }
    }
  },
  mounted () {
    this.measureCameraViewport()
    if (typeof ResizeObserver !== 'undefined') {
      this.cameraObserver = new ResizeObserver(() => { this.measureCameraViewport(); if (this.isIsometric) this.constrainCamera() })
      if (this.$refs.mapViewport) this.cameraObserver.observe(this.$refs.mapViewport)
    }
  },
  beforeDestroy () { this.finishCameraDrag(); this.cameraObserver?.disconnect() },
  methods: {
    measureCameraViewport () { this.cameraViewportWidth = this.$refs.mapViewport?.clientWidth || 0 },
    cameraBounds (zoom = this.zoom) {
      const viewport = this.$refs.mapViewport, stage = this.$refs.mapStage
      if (!viewport || !stage) return null
      return { minX: viewport.clientWidth * .2 - stage.offsetWidth * zoom, maxX: viewport.clientWidth * .8,
        minY: viewport.clientHeight * .2 - stage.offsetHeight * zoom, maxY: viewport.clientHeight * .8 }
    },
    constrainCamera (zoom = this.zoom) {
      const bounds = this.cameraBounds(zoom); if (!bounds) return
      this.cameraX = Math.max(bounds.minX, Math.min(bounds.maxX, this.cameraX))
      this.cameraY = Math.max(bounds.minY, Math.min(bounds.maxY, this.cameraY))
    },
    resetCamera () {
      this.finishCameraDrag(); this.cameraX = 0; this.cameraY = 0; this.cameraBlockClickUntil = 0
      this.$nextTick(() => { const viewport = this.$refs.mapViewport; if (viewport) { viewport.scrollLeft = 0; viewport.scrollTop = 0 } })
    },
    startCameraDrag (event) {
      if (!this.isIsometric || event.button !== 0 || event.isPrimary === false || this.cameraDrag) return
      this.cameraBlockClickUntil = 0
      this.cameraDrag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.cameraX, top: this.cameraY, moved: false }
      // 移动达到阈值后才捕获指针，保证普通点击仍命中原建筑/点位。
    },
    moveCameraDrag (event) {
      const drag = this.cameraDrag
      if (!this.isIsometric || !drag || event.pointerId !== drag.id) return
      const dx = event.clientX - drag.x, dy = event.clientY - drag.y
      if (!drag.moved && Math.hypot(dx, dy) < 4) return
      if (!drag.moved) { drag.moved = true; try { this.$refs.mapViewport.setPointerCapture(drag.id) } catch (_) {} }
      event.preventDefault()
      this.cameraX = drag.left + dx; this.cameraY = drag.top + dy; this.constrainCamera()
    },
    finishCameraDrag (event) {
      const drag = this.cameraDrag
      if (!drag || event && event.pointerId !== drag.id) return
      if (drag.moved) this.cameraBlockClickUntil = Date.now() + 300
      this.cameraDrag = null
      const viewport = this.$refs.mapViewport
      try { if (viewport?.hasPointerCapture(drag.id)) viewport.releasePointerCapture(drag.id) } catch (_) {}
    },
    leaveCameraViewport () { if (this.cameraDrag && !this.cameraDrag.moved) this.finishCameraDrag() },
    setCameraZoom (value, anchor) {
      const next = Number(Math.max(this.minZoom, Math.min(this.maxZoom, value)).toFixed(this.isIsometric ? 4 : 1))
      if (!this.isIsometric) { this.zoom = next; return }
      if (next === this.zoom) return
      const viewport = this.$refs.mapViewport
      if (!viewport) return
      const target = anchor || { x: viewport.clientWidth / 2, y: viewport.clientHeight / 2 }
      const ratio = next / this.zoom
      this.cameraX = target.x - (target.x - this.cameraX) * ratio
      this.cameraY = target.y - (target.y - this.cameraY) * ratio
      this.zoom = next; this.constrainCamera(next)
      // 拖动中滚轮缩放时，从新视野继续拖动，避免下一次pointermove跳回旧位置。
      if (this.cameraDrag) {
        this.cameraDrag.left = this.cameraX; this.cameraDrag.top = this.cameraY
        this.cameraDrag.x = anchor?.clientX ?? this.cameraDrag.x
        this.cameraDrag.y = anchor?.clientY ?? this.cameraDrag.y
      }
    },
    stepCameraZoom (direction) { this.setCameraZoom(Number((this.zoom + direction * this.zoomStep).toFixed(2))) },
    wheelCameraZoom (event) {
      if (!this.isIsometric || !event.deltaY) return
      event.preventDefault()
      const viewport = this.$refs.mapViewport, rect = viewport.getBoundingClientRect()
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientHeight : 1
      const delta = Math.max(-240, Math.min(240, event.deltaY * unit))
      this.setCameraZoom(this.zoom * Math.exp(-delta * .0015), {
        x: event.clientX - rect.left - viewport.clientLeft, y: event.clientY - rect.top - viewport.clientTop,
        clientX: event.clientX, clientY: event.clientY
      })
    }
  }
}
